import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import {
  EducationalExpensesDescription,
  MedicalExpensesDescription,
} from '../../../../components/FormDescriptions';
import {
  buildGroupedCurrencySchemaProperties,
  buildGroupedCurrencyUIProperties,
} from '../../../../definitions';
import content from '../../../../locales/en/content.json';
import { strWithYear } from '../../../../utils/helpers';

const TITLE_TEXT = strWithYear(content['household-info--expenses-title']);
const DESC_TEXT = content['household-info--expenses-description'];

const SCHEMA_CONFIG = [
  {
    dataField: 'deductibleMedicalExpenses',
    subtitle: content['household-info--expenses-medical-title'],
    description: MedicalExpensesDescription,
    label: strWithYear(content['household-info--expenses-medical-label']),
  },
  {
    dataField: 'deductibleEducationExpenses',
    subtitle: content['household-info--expenses-education-title'],
    description: EducationalExpensesDescription,
    label: strWithYear(content['household-info--expenses-education-label']),
  },
  {
    dataField: 'deductibleFuneralExpenses',
    subtitle: content['household-info--expenses-funeral-title'],
    description: content['household-info--expenses-funeral-description'],
    label: strWithYear(content['household-info--expenses-funeral-label']),
  },
];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    ...buildGroupedCurrencyUIProperties(SCHEMA_CONFIG),
  },
  schema: {
    type: 'object',
    required: [
      'view:deductibleMedicalExpenses',
      'view:deductibleEducationExpenses',
      'view:deductibleFuneralExpenses',
    ],
    properties: buildGroupedCurrencySchemaProperties(SCHEMA_CONFIG),
  },
};
